import React from 'react';
import './guide.scss';

export function Guide(props) {
  return (
    <div className="card add_bottom_45">
      <div className="card-body">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <h3>Порядок оказания платных услуг</h3>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="list-group">
            {props.files.map(file => (
              <div className="list-group-item" key={file.name}>
                <a href={`${file.link}`}>
                  <i className="pe-7s-file" />
                  {file.name}
                </a>
                &nbsp; (<a href={`${file.link}?inline=false`}>скачать</a>)
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Guide;
